import { type ReactNode } from 'react';
import { InvoiceHistoryModal } from '../ui/InvoiceHistoryModal';
import { useModalStore } from '@/shared/lib';
import type { InvoiceHistoryResponse } from '../api';

type OpenInvoiceHistoryDialogParams = {
  onBack?: () => void;
  onClose?: () => void;
  invoices?: InvoiceHistoryResponse;
  className?: string;
  customCloseButton?: ReactNode;
};

export function useInvoiceHistoryDialog() {
  const { showDialogComponent } = useModalStore();

  const openInvoiceHistoryDialog = ({
    onBack,
    onClose,
    invoices,
    customCloseButton,
  }: OpenInvoiceHistoryDialogParams = {}) => {
    showDialogComponent({
      component: <InvoiceHistoryModal invoices={invoices} onBack={onBack} />,
      className: 'border-0',
      ...(customCloseButton ? { customCloseButton } : {}),
      onClose,
    });
  };

  return { openInvoiceHistoryDialog };
}
